(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["7ml-main-product-ao"]) return;
  try {
    

  $(document).ready(function(){
    console.log('started');
    $('.full_list_ing').on('click',function(){
      console.log('clicked');
      $('.show__full').slideToggle();
    })
  });

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["7ml-order-columns"] && !window.DesignMode) return;
  try {
    
  function addToCartAndRedirect(productId) {
     $.ajax({
       type: 'POST',
       url: '/cart/add.js',
       data: {
         id: productId,
         quantity: 1
       },
       dataType: 'json',
       success: function() {
         window.location.href = '/cart';
       },
       error: function() {
         alert('There was an error adding the item to the cart.');
       }
     });
   }
  $(document).ready(function() {
     // Function to add item to cart and redirect to cart page
     
  
     // Listen for the button click in the first box
    //  $('#one_time').on('click', function(e) {
    //    e.preventDefault();
    //    // Assuming productId and quantity for the first box
    //    const productId = 'YOUR_PRODUCT_ID_1';
    //    const quantity = 1;
    //    addToCartAndRedirect(productId, quantity);
    //  });
  
     // Listen for the button click in the last box
     $('#subscribe').on('click', function(e) {
       e.preventDefault();
       const button = $(this);
       const subDrop = $('.sub_drop');
       console.log('clicked');
  
       // Check if the sub_drop is already visible
       if (subDrop.is(':visible')) {
         // If already visible, update the button text to "Continue"
          console.log('is visible');
          const productId = $('#prom_quan').val();
          const quantity = 1;
          const subid = $('#prom_freq').val();
          if($('#prom_quan').val() !== 0 && $('#prom_freq').val() !== 0){
           const redirect_checkout = '/a/subscriptions/checkout/'+productId+':1:'+subid+' ';
           console.log(redirect_checkout);
          // Redirect to another page
           window.location.href = redirect_checkout;
        }
          
  
       } else {
        console.log('slide');
         // If not visible, show the sub_drop and change the button text
         subDrop.slideDown();
         button.text('Checkout Now');
       }
     });
   });


  $(document).ready(function() {
   console.log('ready');
   $('.option').on('click', function() {
      console.log('option clicked');
      var option = $(this).data('type');
      var dropId = $(this).data('id');
      console.log('input value: '+$('input[name="option-'+dropId+'"]:checked').val());
      console.log('option: '+option)
      if(option == 'sub') {
         console.log(dropId);
         $('#freq_drop-'+dropId).show();
         $('input[name="option_'+dropId).val('subscribe');
         $('#sell_plan-'+dropId).val('664207465');
         
      }else{
        console.log('not found');
         $('#freq_drop-'+dropId).hide();
         $('#dropout_'+dropId).hide();
         $('input[name="option_'+dropId).val('add');
         $('#subs_interval_select').val('0');
         $('#sell_plan-'+dropId).val('');
         $('#interval_select').val('');
         //$('#sell_plan').val('');
         $("#in_opt-"+dropId).val(0);
      }
      
   });

  // DROP DOWN FREQUENCY SELECTOR
  $('.freq_selected').on('click',function(e) {
     const dropId = $(this).data('rel');
     console.log('Freq_'+dropId);
      if($('#dropout_'+dropId).is(":visible")) {
        $('#dropout_'+dropId).slideUp();
        console.log('toggled up');
      }else{
        $('#dropout_'+dropId).slideDown();
        console.log('toggled down');
      }
      //$('#dropout_'+dropIdd).toggle();
      $('#subs_interval_select').val('1');
      $('#sell_plan-'+dropId).val($(this).data('id'));
      $('#in_opt-'+dropId).val(1);
      console.log('clicked - '+ dropId + ' | Parent id: '+dropId);
   });

  $('.freq_opt').on('click', function(e) {
      const dropId = $(this).data('loop');
         console.log('clicked freq - '+dropId);
         var intsel = $(this).data('rel');
         var sellplan = $(this).data('id');
         var days = $('b',this).html();
         console.log(sellplan);
         $('#interval_select-'+dropId).val(intsel);
         $('#sell_plan-'+dropId).val(sellplan);
         $('.b-'+dropId).html(days);
         $('#dropout_'+dropId).hide();
      });

   // $('.continue-button').on('click', function(e) {
   //    e.preventDefault();
   //    var dropId = $(this).data('id');
   //    //if($('input[name="option_'+dropId+'"]').val() =='add') {
   //       var form = $(this).closest('form');
   //       form.submit();
   //    //
   // });


   // Attach event listener to all continue buttons
document.querySelectorAll('.continue-button').forEach((button) => {
   button.addEventListener('click', function (event) {
     // Get the data-id attribute to determine which form is being submitted
     const formId = button.getAttribute('data-id'); // Get the form identifier (e.g., '1' or '2')
 
     // Variables to hold the form data values
     let formData;
 
     // Check the data-id to decide which form data to use
     if (formId === '1') {
       // If the data-id is '1', use Form 1 values
       formData = {
         id: document.getElementById('product_idd-1').value,
         quantity: document.getElementById('in_quan').value,
         selling_plan: document.getElementById('sell_plan-1').value,
         subs_type: document.getElementById('in_opt-1').value,
         subs_interval: document.getElementById('interval_select-1').value,
       };
     } else if (formId === '2') {
       // If the data-id is '2', use Form 2 values
       formData = {
         id: document.getElementById('product_idd-2').value,
         quantity: document.getElementById('in_quan').value,
         selling_plan: document.getElementById('sell_plan-2').value,
         subs_type: document.getElementById('in_opt-2').value,
         subs_interval: document.getElementById('interval_select-2').value,
       };
     } else if (formId === '3') {
       // If the data-id is '2', use Form 2 values
       formData = {
         id: document.getElementById('product_idd-3').value,
         quantity: document.getElementById('in_quan').value,
         selling_plan: document.getElementById('sell_plan-3').value,
         subs_type: document.getElementById('in_opt-3').value,
         subs_interval: document.getElementById('interval_select-3').value,
       };
     }
 
     // Make sure formData is not undefined before making the fetch request
     if (formData) {
       fetch('/cart/add.js', {
         method: 'POST',
         headers: {
           'Content-Type': 'application/json',
         },
         body: JSON.stringify(formData),
       })
         .then((response) => response.json())
         .then((data) => {
           window.location.href = '/cart'; // Redirect to checkout
           //window.location.href = '/checkout'; // Redirect to checkout
         })
         .catch((error) => {
           console.error('Error:', error);
         });
     } else {
       console.error('Form data is undefined, check button data-id and input IDs.');
     }
   });
 });
}); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
